import { useMemo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { DataSourceItem, SortDirection, Table as TableUI } from 'ui/components'
import { SiteAuditDocumentsReportItem } from '~bank-reports/types/SiteAuditDocumentsReport'

import { useSiteAuditDocumentsReportContext } from '../../context/SiteAuditDocumentsReportContext'
import { columns } from './columns'

export const Table = () => {
  const { data, state, navigate, isPending } = useSiteAuditDocumentsReportContext()

  const mappedItems: DataSourceItem<SiteAuditDocumentsReportItem>[] = useMemo(
    () =>
      data?.items?.map((el) => ({
        item: el
      })),
    [data?.items]
  )

  return (
    <TableUI
      dataQa={TableDataQa.BP_REPORTS_SITE_AUDIT_DOCUMENTS_REPORT}
      columns={columns(data?.availableSortFields)}
      loading={isPending}
      dataSource={mappedItems}
      sorting={{
        order: [
          {
            field: state?.sortBy || '',
            direction: state.sortDesc ? 'DESC' : 'ASC'
          }
        ],
        onChange: (sorting) => {
          navigate({ sortBy: sorting.field, sortDesc: sorting.direction === SortDirection.DESC })
        }
      }}
      pagination={{
        page: state.page,
        size: state.size,
        onChange: (page, size) => {
          navigate({ page, size })
        },
        total: data?.total
      }}
    />
  )
}
